<!-- Navbar -->
<nav class="navbar navbar-expand-lg navbar-dark bg-black fixed-top">
    <div class="container">
        <a class="navbar-brand py-0" routerLink="/" (click)="collapse.hide()">
            <img ngSrc="/assets/img/skokbouw-2x.webp" height="60" width="249" alt="Skokbouw Logo"
                class="d-inline-block align-top" priority>
        </a>
        <button class="navbar-toggler" type="button" (click)="collapse.toggle()" aria-controls="navbarSupportedContent"
            aria-expanded="false" aria-label="Toggle navigation">
            <app-icon name="bars" size="24"></app-icon>
        </button>
        <div mdbCollapse #collapse="mdbCollapse" class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item">
                    <a class="nav-link" routerLink="/totaalrenovatie" (click)="collapse.hide()">Totaalrenovatie</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/gyprocwerken" (click)="collapse.hide()">Gyprocwerken</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/badkamerrenovatie" (click)="collapse.hide()">Badkamer</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/zolderrenovatie" (click)="collapse.hide()">Zolder</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/energetische-renovatie" (click)="collapse.hide()">Energie</a>
                </li>
            </ul>
            <ul class="navbar-nav ms-auto mb-2 mb-lg-0 flex-row gap-3">
                <li class="nav-item">
                    <a class="nav-link" href="https://www.google.com/maps/search/?api=1&query=Skokbouw+Gent"
                        target="_blank" title="Bekijk ons werkgebied in Gent" aria-label="Google Maps Gent">
                        <app-icon name="location-dot" size="20"></app-icon>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="https://www.facebook.com/skobouw" target="_blank" title="Facebook"
                        aria-label="Facebook">
                        <app-icon name="facebook-f" size="20"></app-icon>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link"
                        href="https://wa.me/32465758105?text=Hallo%20Skokbouw%2C%20ik%20heb%20een%20vraag%20over%20een%20renovatieproject..."
                        target="_blank" title="WhatsApp" aria-label="Chat via WhatsApp">
                        <app-icon name="whatsapp" size="20"></app-icon>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</nav>

<router-outlet></router-outlet>

<footer class="page-footer font-small blue-grey lighten-5">
    <div style="background-color: #d12121;">
        <div class="container">
            <div class="row py-4 d-flex align-items-center justify-content-center">
                <div class="col-12 text-center">
                    <a href="https://www.facebook.com/skobouw" target="_blank"
                        class="h6 mb-0 text-white text-decoration-none">
                        <span class="me-3">Bekijk onze realisaties op Facebook</span>
                        <app-icon name="facebook-f" size="24"></app-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="container text-center text-md-start mt-5">
        <div class="row mt-3">
            <div class="col-md-4 col-lg-4 col-xl-4 mb-4 text-center text-md-start">
                <p class="h6 text-uppercase fw-bold">skokbouw</p>
                <hr class="bg-danger mb-4 mt-0 d-inline-block mx-auto" style="width: 60px; height: 2px; opacity: 1;">
                <p>Renovatie als een vorm van kunst. Stap voor stap naar het perfecte resultaat met oog voor het
                    kleinste detail en transparante prijzen per meter.</p>
            </div>
            <div class="col-md-4 col-lg-4 col-xl-4 mb-4 text-center text-md-start">
                <!-- Links -->
                <p class="h6 text-uppercase fw-bold">Diensten</p>
                <hr class="bg-danger mb-4 mt-0 d-inline-block mx-auto" style="width: 60px; height: 2px; opacity: 1;">
                <p><a routerLink="/totaalrenovatie" class="text-reset">Totaalrenovatie</a></p>
                <p><a routerLink="/gyprocwerken" class="text-reset">Gyprocwerken</a></p>
                <p><a routerLink="/badkamerrenovatie" class="text-reset">Badkamerrenovatie</a></p>
                <p><a routerLink="/zolderrenovatie" class="text-reset">Zolderrenovatie</a></p>
                <p><a routerLink="/energetische-renovatie" class="text-reset">Energetische Renovatie</a></p>
            </div>
            <div class="col-md-4 col-lg-4 col-xl-4 mb-md-0 mb-4 text-center text-md-start">
                <p class="h6 text-uppercase fw-bold">Contact</p>
                <hr class="bg-danger mb-4 mt-0 d-inline-block mx-auto" style="width: 60px; height: 2px; opacity: 1;">
                <p>
                    <a href="https://www.google.com/maps/search/?api=1&query=Skokbouw+Wetteren" target="_blank"
                        class="text-reset text-decoration-none">
                        <app-icon name="house" size="18" className="me-3 text-danger"></app-icon>
                        Markt 14/21, 9230 Wetteren
                    </a>
                </p>
                <p class="text-reset">
                    <app-icon name="id-card" size="18" className="me-3 text-danger"></app-icon>
                    BTW: BE 0697.778.804
                </p>
                <p>
                    <a href="mailto:info@skokbouw.be" class="text-reset text-decoration-none">
                        <app-icon name="envelope" size="18" className="me-3 text-danger"></app-icon>
                        info&#64;skokbouw.be
                    </a>
                </p>
                <p>
                    <a href="tel:+32465758105" class="text-reset text-decoration-none">
                        <app-icon name="phone" size="18" className="me-3 text-danger"></app-icon>
                        +32 465 75 81 05
                    </a>
                </p>
                <p>
                    <a href="https://wa.me/32465758105?text=Hallo%20Skokbouw%2C%20ik%20heb%20een%20vraag%20over%20een%20renovatieproject..."
                        target="_blank" class="text-reset text-decoration-none">
                        <app-icon name="whatsapp" size="18" className="me-3 text-danger"></app-icon>
                        WhatsApp
                    </a>
                </p>
            </div>
        </div>
    </div>
    <div class="footer-copyright text-center py-3 border-top">
        <div class="container d-flex flex-column flex-md-row justify-content-between align-items-center">
            <div class="mb-2 mb-md-0">
                © {{ year }} Copyright: <a style="color: #555; font-weight: bold;" routerLink="/"> skokbouw.be</a>
            </div>
            <div class="legal-links">
                <a routerLink="/privacy-policy" style="color: #555;" class="small me-3">Privacybeleid</a>
                <a routerLink="/wettelijke-vermeldingen" style="color: #555;" class="small">Wettelijke vermeldingen</a>
            </div>
        </div>
    </div>
</footer>